// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field[data-v-05186f29]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:18px}.label[data-v-05186f29]{width:145px;font-weight:500;text-transform:uppercase;font-size:11px}", ""]);
// Exports
module.exports = exports;
